// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../types';

import gql from 'graphql-tag';
import { AllPropsProposalCardProposalFragmentDoc } from './ProposalCard/ProposalCard.generated-types';
import { AllPropsEnquiryDetailsEventFragmentDoc } from './EnquiryDetails/EnquiryDetails.generated-types';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AllProposalsEventQueryVariables = Types.Exact<{
  UUID: Types.Scalars['ID'];
}>;


export type AllProposalsEventQuery = { __typename?: 'Query', getEventByUUID: { __typename?: 'Event', UUID: string, status: Types.EventStatus, name: string, budget: number, currency: string, attendees: number, location: string, cateringNeeds?: string | null, additionalNotes?: string | null, fromDateTime: string, toDateTime: string, proposals: Array<{ __typename?: 'Proposal', UUID: string, attendees: number, currency: string, status: Types.ProposalStatus, baseCostTotal: number, space: { __typename?: 'SelfServeSpace', spaceName?: string | null, spacePhotos?: Array<{ __typename?: 'SelfServeSpacePhoto', url?: string | null }> | null, venue?: { __typename?: 'SelfServeVenue', name?: string | null, nearestTransit?: { __typename?: 'NearestTransit', station?: string | null, distanceKm?: number | null } | null } | null } }>, spaceFacilities?: Array<{ __typename?: 'SpaceFacility', id: number, name: string }> | null } };


export const AllProposalsEventDocument = gql`
    query AllProposalsEvent($UUID: ID!) {
  getEventByUUID(UUID: $UUID) {
    UUID
    status
    proposals {
      ...AllPropsProposalCardProposal
    }
    ...AllPropsEnquiryDetailsEvent
  }
}
    ${AllPropsProposalCardProposalFragmentDoc}
${AllPropsEnquiryDetailsEventFragmentDoc}`;

export function useAllProposalsEventQuery(options: Omit<Urql.UseQueryArgs<AllProposalsEventQueryVariables>, 'query'>) {
  return Urql.useQuery<AllProposalsEventQuery>({ query: AllProposalsEventDocument, ...options });
};